// Login screen of the admin surface: email and password; one message for a wrong email or password; «Забыли пароль?» sends a link.

import { useState } from 'react';
import { Button, Input, Field } from '../ui/primitives.tsx';
import s from './shell.module.css';

export function Login({ onDone }: { onDone: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState<'no' | 'form' | 'sent'>('no');
  const sendReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const r = await fetch('/api/auth/forgot', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ email }) });
      if (r.ok) setForgot('sent'); else setError(((await r.json()) as { error?: { message?: string } }).error?.message ?? 'Не удалось отправить');
    } catch { setError('Сервер недоступен. Проверьте соединение.'); } finally { setBusy(false); }
  };
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const r = await fetch('/api/auth/login', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ email, password }) });
      if (r.ok) onDone();
      else setError(((await r.json()) as { error?: { message?: string } }).error?.message ?? 'Не удалось войти');
    } catch {
      setError('Сервер недоступен. Проверьте соединение.');
    } finally {
      setBusy(false);
    }
  };
  if (forgot !== 'no') return (
    <div className={s.login}>
      <form className={s.loginCard} onSubmit={sendReset}>
        <div className={s.logo}>CD</div>
        <h1 className={s.loginTitle}>Восстановление пароля</h1>
        {forgot === 'sent' ? <p className={s.loginHint} role="status">Если такой адрес есть в пространстве, письмо со ссылкой уже в почте. Ссылка действует 1 час.</p> : <>
          <p className={s.loginHint}>Пришлём ссылку для нового пароля.</p>
          <Field className={s.big} label="Email"><Input type="email" autoComplete="username" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} required /></Field>
          {error && <div className={s.loginError} role="alert">{error}</div>}
          <Button type="submit" variant="primary" size="lg" disabled={busy}>Прислать ссылку</Button></>}
        <Button onClick={() => { setForgot('no'); setError(null); }}>Ко входу</Button>
      </form>
    </div>
  );
  return (
    <div className={s.login}>
      <form className={s.loginCard} onSubmit={submit}>
        <div className={s.logo}>CD</div>
        <h1 className={s.loginTitle}>Вход в ConfDeck</h1>
        <Field className={s.big} label="Email"><Input type="email" autoComplete="username" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} required /></Field>
        <Field className={s.big} label="Пароль"><Input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
        {error && <div className={s.loginError} role="alert">{error}</div>}
        <Button type="submit" variant="primary" size="lg" disabled={busy}>Войти</Button>
        <Button onClick={() => { setForgot('form'); setError(null); }}>Забыли пароль?</Button>
      </form>
    </div>
  );
}
